import React from "react";
import BookingLink from "../../components/button/BookingLink";

const Actions = () => {
  return (
    <div className="actions">
      <div className="actions-items">
        <BookingLink className="actions-item">Réserver</BookingLink>
      </div>
    </div>
  );
};

export default Actions;
